module.exports = __webpack_public_path__ + "static/media/viruz.8ae78882.svg";